// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__Api from "../../../core/Api.js";
import * as Buhta_landing__Awards from "./Awards.js";
import * as Buhta_landing__Company from "./Company/Company.js";
import * as Buhta_landing__CompanyDetailsPage from "./CompanyDetailsPage.js";
import * as Buhta_landing__Contact from "./Contact.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__Job from "./Jobs/Job.js";
import * as Buhta_landing__JobUtils from "./Jobs/JobUtils.js";
import * as Buhta_landing__Jobs from "./Jobs/Jobs.js";
import * as Buhta_landing__LeftMenuItem from "./LeftMenu/LeftMenuItem.js";
import * as Buhta_landing__LeftMenuMobile from "./LeftMenu/LeftMenuMobile.js";
import * as Buhta_landing__Licenses from "./Licenses.js";
import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Buhta_landing__Partners from "./Partners/Partners.js";
import * as Buhta_landing__Pricing from "./Pricing/Pricing.js";
import * as Buhta_landing__PricingContactForm from "./Pricing/PricingContactForm.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Buhta_landing__Security from "./Security.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function About(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const currentRoute = Buhta_landing__Route.ofUrl(Buhta_landing__Route.useUrl(undefined));
  const country = Buhta_landing__Route.getCountry(undefined);
  const language = Buhta_landing__Route.getLanguage(undefined);
  const intl = ReactIntl.useIntl();
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const dispatchContent = match[1];
  const jobCategories = match[0].jobCategories;
  React.useEffect((function () {
    const __x = $$Promise.all({
      hd: Buhta_landing__Api.jobCategories(undefined),
      tl: /* [] */ 0
    });
    $$Promise.get(__x, (function (respList) {
      Stdlib__List.iter((function (res) {
        Buhta_landing__Api.handleResponse(res, dispatchContent, undefined);
      }), respList);
    }));
  }), []);
  const job = Buhta_landing__JobUtils.getCurrentJob(currentRoute, jobCategories);
  const breadcrumbs_0 = {
    label: job.name,
    route: {
      TAG: /* Landing */ 0,
      _0: country,
      _1: language,
      _2: {
        TAG: /* Job */ 0,
        _0: job.slug
      }
    },
    parentLabel: Buhta_landing__I18n.trans(intl, "jobs"),
    parentRoute: {
      TAG: /* Landing */ 0,
      _0: country,
      _1: language,
      _2: /* Jobs */ 9
    }
  };
  const breadcrumbs_1 = {
    hd: {
      label: "Консультации по бухгалтерскому учету и налогообложению",
      route: {
        TAG: /* Landing */ 0,
        _0: country,
        _1: language,
        _2: /* ContactForm */ 6
      },
      parentLabel: Buhta_landing__I18n.trans(intl, "pricing"),
      parentRoute: {
        TAG: /* Landing */ 0,
        _0: country,
        _1: language,
        _2: /* Pricing */ 5
      }
    },
    tl: /* [] */ 0
  };
  const breadcrumbs = {
    hd: breadcrumbs_0,
    tl: breadcrumbs_1
  };
  const leftMenuList_0 = {
    routes: {
      hd: {
        TAG: /* Landing */ 0,
        _0: country,
        _1: language,
        _2: /* About */ 3
      },
      tl: /* [] */ 0
    },
    label: Buhta_landing__I18n.trans(intl, "about")
  };
  const leftMenuList_1 = {
    hd: {
      routes: {
        hd: {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* Partners */ 4
        },
        tl: /* [] */ 0
      },
      label: Buhta_landing__I18n.trans(intl, "partners")
    },
    tl: {
      hd: {
        routes: {
          hd: {
            TAG: /* Landing */ 0,
            _0: country,
            _1: language,
            _2: /* Pricing */ 5
          },
          tl: {
            hd: {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: /* ContactForm */ 6
            },
            tl: /* [] */ 0
          }
        },
        label: Buhta_landing__I18n.trans(intl, "pricing")
      },
      tl: {
        hd: {
          routes: {
            hd: {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: /* Contact */ 7
            },
            tl: /* [] */ 0
          },
          label: Buhta_landing__I18n.trans(intl, "contacts")
        },
        tl: {
          hd: {
            routes: {
              hd: {
                TAG: /* Landing */ 0,
                _0: country,
                _1: language,
                _2: /* CompanyDetails */ 8
              },
              tl: /* [] */ 0
            },
            label: Buhta_landing__I18n.trans(intl, "company_details")
          },
          tl: {
            hd: {
              routes: {
                hd: {
                  TAG: /* Landing */ 0,
                  _0: country,
                  _1: language,
                  _2: /* Jobs */ 9
                },
                tl: {
                  hd: {
                    TAG: /* Landing */ 0,
                    _0: country,
                    _1: language,
                    _2: {
                      TAG: /* Job */ 0,
                      _0: job.slug
                    }
                  },
                  tl: /* [] */ 0
                }
              },
              label: Buhta_landing__I18n.trans(intl, "jobs")
            },
            tl: {
              hd: {
                routes: {
                  hd: {
                    TAG: /* Landing */ 0,
                    _0: country,
                    _1: language,
                    _2: /* Awards */ 10
                  },
                  tl: /* [] */ 0
                },
                label: Buhta_landing__I18n.trans(intl, "awards")
              },
              tl: {
                hd: {
                  routes: {
                    hd: {
                      TAG: /* Landing */ 0,
                      _0: country,
                      _1: language,
                      _2: /* Licenses */ 11
                    },
                    tl: /* [] */ 0
                  },
                  label: Buhta_landing__I18n.trans(intl, "licenses")
                },
                tl: {
                  hd: {
                    routes: {
                      hd: {
                        TAG: /* Landing */ 0,
                        _0: country,
                        _1: language,
                        _2: /* Security */ 12
                      },
                      tl: /* [] */ 0
                    },
                    label: Buhta_landing__I18n.trans(intl, "security")
                  },
                  tl: /* [] */ 0
                }
              }
            }
          }
        }
      }
    }
  };
  const leftMenuList = {
    hd: leftMenuList_0,
    tl: leftMenuList_1
  };
  let background;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Landing */ 0) {
    background = "bg-bg";
  } else {
    let tmp = currentRoute._2;
    if (/* tag */ typeof tmp === "number" || typeof tmp === "string") {
      switch (tmp) {
        case /* Partners */ 4 :
        case /* ContactForm */ 6 :
        case /* Contact */ 7 :
        case /* CompanyDetails */ 8 :
        case /* Jobs */ 9 :
        case /* Awards */ 10 :
        case /* Licenses */ 11 :
        case /* Security */ 12 :
          background = "bg-white";
          break;
        default:
          background = "bg-bg";
      }
    } else {
      background = tmp.TAG === /* Job */ 0 ? "bg-white" : "bg-bg";
    }
  }
  let breadcrumb;
  try {
    breadcrumb = Stdlib__List.find((function (b) {
      return Caml_obj.caml_equal(b.route, currentRoute);
    }), breadcrumbs);
  }
  catch (exn){
    breadcrumb = undefined;
  }
  let tmp$1;
  let exit = 0;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Landing */ 0) {
    exit = 1;
  } else {
    let exit$1 = 0;
    let tmp$2 = currentRoute._2;
    if (/* tag */ typeof tmp$2 === "number" || typeof tmp$2 === "string") {
      switch (tmp$2) {
        case /* About */ 3 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__Company.make, {});
          break;
        case /* Partners */ 4 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__Partners.make, {});
          break;
        case /* Pricing */ 5 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__Pricing.make, {});
          break;
        case /* ContactForm */ 6 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__PricingContactForm.make, {});
          break;
        case /* Contact */ 7 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__Contact.make, {});
          break;
        case /* CompanyDetails */ 8 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__CompanyDetailsPage.make, {});
          break;
        case /* Jobs */ 9 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__Jobs.make, {});
          break;
        case /* Awards */ 10 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__Awards.make, {});
          break;
        case /* Licenses */ 11 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__Licenses.make, {});
          break;
        case /* Security */ 12 :
          tmp$1 = JsxRuntime.jsx(Buhta_landing__Security.make, {});
          break;
        default:
          exit$1 = 2;
      }
    } else if (tmp$2.TAG === /* Job */ 0) {
      tmp$1 = JsxRuntime.jsx(Buhta_landing__Job.make, {});
    } else {
      exit$1 = 2;
    }
    if (exit$1 === 2) {
      tmp$1 = JsxRuntime.jsx("div", {
        className: "h-screen"
      });
    }
    
  }
  if (exit === 1) {
    tmp$1 = JsxRuntime.jsx("div", {
      className: "h-screen"
    });
  }
  return JsxRuntime.jsx(React.Fragment, {
    children: JsxRuntime.jsxs("div", {
      children: [
        breadcrumb !== undefined ? JsxRuntime.jsxs("p", {
            children: [
              JsxRuntime.jsx(Buhta_landing__Link.make, {
                route: breadcrumb.parentRoute,
                className: "underline",
                children: breadcrumb.parentLabel
              }),
              " ･ ",
              breadcrumb.label
            ],
            className: "paragraph-small lg:w-304 mt-10 lg:mt-6 lg:self-center px-6 sm:px-48 lg:px-0 text-gray-landing"
          }) : null,
        JsxRuntime.jsxs("div", {
          children: [
            deviceType === "mobile" || deviceType === "tablet" ? (
                breadcrumb === undefined ? JsxRuntime.jsx(Buhta_landing__LeftMenuMobile.make, {
                    leftMenuList: leftMenuList
                  }) : null
              ) : JsxRuntime.jsx("div", {
                children: Belt__Belt_List.toArray(Stdlib__List.mapi((function (index, item) {
                  const Key = "left_menu_item_" + String(index);
                  return JsxRuntime.jsx(Buhta_landing__LeftMenuItem.make, {
                    routes: item.routes,
                    label: item.label
                  }, Key);
                }), leftMenuList)),
                className: "w-70 mr-8"
              }),
            JsxRuntime.jsx("div", {
              children: tmp$1,
              className: "lg:w-148"
            })
          ],
          className: "lg:w-304 lg:flex lg:m-auto lg:mt-20"
        })
      ],
      className: Cn.fromList({
        hd: background,
        tl: {
          hd: "flex flex-col pb-10 lg:pb-20",
          tl: /* [] */ 0
        }
      })
    })
  });
}

const make = About;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
